var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_18735_50576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 8V13.5714H16.4286V11.7143H19.1853C18.75 11.1339 18.2083 10.6793 17.5603 10.3504C16.9122 10.0216 16.2254 9.85714 15.5 9.85714C14.9293 9.85714 14.3925 9.95387 13.8895 10.1473C13.3865 10.3408 12.9271 10.6068 12.5112 10.9453C12.0952 11.2839 11.7567 11.6949 11.4955 12.1786C11.2344 12.6622 11.0506 13.1797 10.9442 13.731L9.10156 13.4118C9.23698 12.6283 9.49814 11.9077 9.88504 11.25C10.2719 10.5923 10.7459 10.0216 11.3069 9.53795C11.8679 9.05432 12.5112 8.67708 13.2366 8.40625C13.9621 8.13542 14.7165 8 15.5 8C16.3802 8 17.2217 8.16927 18.0246 8.50781C18.8274 8.84635 19.5335 9.33966 20.1429 9.98772V8H22ZM15.5 19.1429C16.061 19.1429 16.5978 19.0461 17.1105 18.8527C17.6231 18.6592 18.0826 18.3932 18.4888 18.0547C18.8951 17.7161 19.2336 17.3051 19.5045 16.8214C19.7753 16.3378 19.9591 15.8203 20.0558 15.269L21.8984 15.5882C21.763 16.3717 21.5019 17.0923 21.115 17.75C20.7281 18.4077 20.2541 18.9784 19.6931 19.4621C19.1321 19.9457 18.4888 20.3229 17.7634 20.5938C17.0379 20.8646 16.2835 21 15.5 21C14.6198 21 13.7783 20.8307 12.9754 20.4922C12.1726 20.1536 11.4665 19.6603 10.8571 19.0123V21H9V15.4286H14.5714V17.2857H11.8147C12.25 17.8661 12.7917 18.3207 13.4397 18.6496C14.0878 18.9784 14.7746 19.1429 15.5 19.1429Z",
    fill: "#41558D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_18735_50576",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_18735_50576"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18735_50576"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_18735_50576",
    result: "effect2_dropShadow_18735_50576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_18735_50576",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3fa52ede9995d0f76cec609c1bdd15ed.svg";
export { ForwardRef as ReactComponent };